import React, { useState } from 'react';
import {
    Box,
    Paper,
    Tabs,
    Tab,
    Typography,
    Divider
} from '@mui/material';
import { SubgraphProvider } from '../../context/SubgraphContext';
import TimelockOperations from '../timelock/TimelockOperations-v2';

// Interface for tab panel props
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

// Tab panel component
function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`subgraph-tabpanel-${index}`}
            aria-labelledby={`subgraph-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

// Main SubgraphExplorer component
const SubgraphExplorer: React.FC = () => {
    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };

    return (
        <SubgraphProvider initialChainId="8453">
            <Box sx={{ width: '100%' }}>
                <Typography variant="h5" gutterBottom>
                    Subgraph Explorer
                </Typography>
                <Divider sx={{ mb: 2 }} />

                <Paper sx={{ mb: 4 }}>
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        aria-label="subgraph tabs"
                        centered
                    >
                        <Tab label="Timelock Operations" />
                        <Tab label="Core Events" />
                        <Tab label="Features Events" />
                        <Tab label="Controller Events" />
                    </Tabs>

                    <TabPanel value={tabValue} index={0}>
                        <TimelockOperations />
                    </TabPanel>

                    <TabPanel value={tabValue} index={1}>
                        <Typography variant="h5">Core Events</Typography>
                        <Typography variant="body1" color="text.secondary">
                            This tab will display events from the MemerCore contract.
                        </Typography>
                    </TabPanel>

                    <TabPanel value={tabValue} index={2}>
                        <Typography variant="h5">Features Events</Typography>
                        <Typography variant="body1" color="text.secondary">
                            This tab will display events from the MemerFeatures contract.
                        </Typography>
                    </TabPanel>

                    <TabPanel value={tabValue} index={3}>
                        <Typography variant="h5">Controller Events</Typography>
                        <Typography variant="body1" color="text.secondary">
                            This tab will display events from the MemerController contract.
                        </Typography>
                    </TabPanel>
                </Paper>
            </Box>
        </SubgraphProvider>
    );
};

export default SubgraphExplorer;
